import { ElementRef } from '@angular/core';
import { TimedWidget } from './TimedWidget';
import { IDataWidget } from '../redux/timeline-data.model';

export class StageWidget extends TimedWidget {

	public elRef: ElementRef;
	public visibility = 'visible';

	constructor( data: IDataWidget ) {
		super( data );
	}
}
